import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function submitContactInquiry(payload) {
  const { data } = await axios.post(`${API}/contact`, payload);
  return data;
}

export async function fetchContent() {
  const { data } = await axios.get(`${API}/content`);
  return data;
}

export async function subscribeNewsletter(email) {
  const { data } = await axios.post(`${API}/newsletter`, { email });
  return data;
}

export const getToken = () => localStorage.getItem("et-admin-token");
export const setToken = (t) =>
  t ? localStorage.setItem("et-admin-token", t) : localStorage.removeItem("et-admin-token");

const auth = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const admin = {
  async login(password) {
    const { data } = await axios.post(`${API}/admin/login`, { password });
    setToken(data.token);
    return data;
  },
  list: async (coll) => (await axios.get(`${API}/admin/${coll}`, auth())).data,
  create: async (coll, item) => (await axios.post(`${API}/admin/${coll}`, item, auth())).data,
  update: async (coll, id, item) => (await axios.put(`${API}/admin/${coll}/${id}`, item, auth())).data,
  remove: async (coll, id) => (await axios.delete(`${API}/admin/${coll}/${id}`, auth())).data,
  inquiries: async () => (await axios.get(`${API}/admin/inquiries`, auth())).data,
  subscribers: async () => (await axios.get(`${API}/admin/subscribers`, auth())).data,
  removeSubscriber: async (id) => (await axios.delete(`${API}/admin/subscribers/${id}`, auth())).data,
  getSettings: async () => (await axios.get(`${API}/admin/settings`, auth())).data,
  saveSettings: async (s) => (await axios.put(`${API}/admin/settings`, s, auth())).data,
  getSeo: async () => (await axios.get(`${API}/admin/seo`, auth())).data,
  saveSeo: async (s) => (await axios.put(`${API}/admin/seo`, s, auth())).data,
  async upload(file) {
    const form = new FormData();
    form.append("file", file);
    const { data } = await axios.post(`${API}/admin/upload`, form, auth());
    return data;
  },
};

export const fileUrl = (f) =>
  !f ? "" : f.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${f}` : f;
